
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/forgot-password",
      function () {
        return require("private-next-pages/account/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/forgot-password"])
      });
    }
  